import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/stock-profit',
  component: () => import('../../routes/StockProfitCalculator.svelte'),
  card: {
    id: 'stock-profit',
    title: 'Stock Profit',
    description: 'Calculate your net profit or loss from buying and selling stocks including fees.',
    icon: 'show_chart',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/stock-profit',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Stock Profit Calculator – Stock Trading Profit & Loss Calculator',
    description: 'Free stock profit calculator. Calculate net profit or loss from buying and selling stocks, including broker commissions, break-even price, total return percentage, and profit per share.',
  },
};

export default meta;
